import { render, staticRenderFns } from "./Incidencia.vue?vue&type=template&id=13b30238"
import script from "./Incidencia.vue?vue&type=script&lang=js"
export * from "./Incidencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports